import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticElectricMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({province}) => {
    const hasProvince = Boolean(province)

    // These are the unique combination of SEO Metadata typology
    // for electric ads-list pages [/electricas/]
    const isDefault = !hasProvince
    const isProvince = hasProvince

    if (isDefault) return 'default'
    if (isProvince) return 'province'
  }

  map = ({adsListSemanticConfig, params: {province}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      province
    })

    return adsListSemanticConfig[adsListSemanticConfigKey]
  }
}
